import React from "react";
import { colors, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((_) => ({
  domainsList: {
    background: colors.grey[100],
    borderRadius: "0.25em",
    marginBottom: "1em",
    padding: "0.5em 0.75em",
  },
}));

export type DomainsListProps = {
  domains: string[];
};

function DomainsList({ domains }: DomainsListProps) {
  const classes = useStyles();

  return (
    <div className={classes.domainsList}>
      <Typography component="p" variant="body1">
        This tool is associated with the{" "}
        {domains.length > 1 ? "following domains: " : "domain "}
        <>
          {domains.sort().reduce((acc, domain, idx) => {
            if (idx === domains.length - 1) {
              return [...acc, <strong key={domain}>{domain}</strong>];
            }

            return [
              ...acc,
              <strong key={domain}>{domain}</strong>,
              <span key={`${domain}-sep`}>{", "}</span>,
            ];
          }, [] as React.ReactNode[])}
        </>
      </Typography>
    </div>
  );
}

export default DomainsList;
